import type { StyledSvg } from "baseui/icon";
import React from "react";
import { SmallArrowIcon } from "./SmallArrowIcon";

export const ForwardArrowIcon = (props: React.ComponentProps<typeof StyledSvg>) => <SmallArrowIcon direction="right" {...props} />;
